import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Lock, Loader2, LogIn } from 'lucide-react';
import { adminLogin } from '../../lib/adminApi';

const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  if (localStorage.getItem('hh_admin_token')) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await adminLogin(username, password);
      localStorage.setItem('hh_admin_token', data.token);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'w-full bg-zinc-950 border border-zinc-800 text-white px-4 py-3 rounded text-sm focus:outline-none focus:border-[#909090]';

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-md bg-zinc-950 border border-zinc-900 rounded-lg p-8">
        <div className="flex items-center gap-3 mb-2">
          <Lock className="text-[#909090]" size={22} />
          <h1 className="text-2xl font-bold text-white">Admin Login</h1>
        </div>
        <p className="text-zinc-500 text-sm mb-6">Hydro Health admin dashboard</p>

        {error && (
          <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded">{error}</div>
        )}

        <label className="text-zinc-400 text-xs uppercase tracking-wider mb-1.5 block">Username</label>
        <input value={username} onChange={(e) => setUsername(e.target.value)} required className={`${inputCls} mb-4`} />

        <label className="text-zinc-400 text-xs uppercase tracking-wider mb-1.5 block">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={`${inputCls} mb-6`} />

        <button disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold py-3 rounded transition-colors disabled:opacity-60">
          {loading ? <><Loader2 className="animate-spin" size={18}/> Signing in...</> : <><LogIn size={18}/> Sign in</>}
        </button>
        <p className="text-zinc-600 text-xs text-center mt-6">Default: admin / hydrohealth2026 — change in backend/.env</p>
      </form>
    </div>
  );
};

export default AdminLoginPage;
